export interface Category {
  id: string;
  namePl: string;
  nameEn: string;
  link: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    namePl: 'Buty',
    nameEn: 'Shoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-01',
  },
  {
    id: 'hoodies',
    namePl: 'Bluzy/Swetry',
    nameEn: 'Hoodies/Sweaters',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodies-02',
  },
  {
    id: 'tshirts',
    namePl: 'T-Shirty',
    nameEn: 'T-Shirts',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirts-03',
  },
  {
    id: 'jackets',
    namePl: 'Kurtki',
    nameEn: 'Jackets',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jackets-04',
  },
  {
    id: 'pants',
    namePl: 'Spodnie/Szorty',
    nameEn: 'Pants/Shorts',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants-05',
  },
  {
    id: 'headwear',
    namePl: 'Nakrycia głowy',
    nameEn: 'Headwear',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear-06',
  },
  {
    id: 'sets',
    namePl: 'Zestawy',
    nameEn: 'Sets',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets-07',
  },
  {
    id: 'underwear',
    namePl: 'Bielizna',
    nameEn: 'Underwear/Underpants',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear-08',
  },
  {
    id: 'jersey',
    namePl: 'Koszulki sportowe',
    nameEn: 'Jersey',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey-09',
  },
  {
    id: 'accessories',
    namePl: 'Akcesoria',
    nameEn: 'Accessories',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories-10',
  },
  {
    id: 'bags',
    namePl: 'Torby',
    nameEn: 'Bags',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags-11',
  },
  {
    id: 'belts',
    namePl: 'Paski',
    nameEn: 'Belts',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts-12',
  },
  {
    id: 'perfumes',
    namePl: 'Perfumy',
    nameEn: 'Perfumes',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes-13',
  },
  {
    id: 'other',
    namePl: 'Inne',
    nameEn: 'Other Stuff',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other-14',
  },
];

export const faqItems = [
  {
    question: 'Czy Kakobuy Spreadsheet działa w Polsce?',
    answer: 'Tak, Kakobuy Spreadsheet jest w pełni dostępny dla użytkowników z Polski. Listy produktów obejmują przedmioty z Taobao, Weidian i 1688, które można zamawiać z dostawą do Polski za pośrednictwem agenta Kakobuy. Wszystkie kategorie produktów są regularnie aktualizowane, a informacje o wysyłce do Polski są jasno opisane.',
  },
  {
    question: 'Jak znaleźć najlepsze produkty za pomocą Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet organizuje produkty według kategorii, co znacznie ułatwia wyszukiwanie. Każdy produkt zawiera link bezpośredni, zdjęcia QC oraz informacje o sprzedawcy. Wystarczy wybrać interesującą kategorię, przejrzeć listę i kliknąć w produkt, aby przejść do strony zakupu.',
  },
  {
    question: 'Czy zakupy przez Kakobuy Spreadsheet są bezpieczne?',
    answer: 'Zakupy przez Kakobuy Spreadsheet są bezpieczne, ponieważ platforma współpracuje ze zweryfikowanymi sprzedawcami. Dodatkowo dostępne są zdjęcia QC (kontroli jakości) dla każdego zamówienia, co pozwala sprawdzić produkt przed wysyłką do Polski. Płatności są chronione, a w przypadku problemów dostępna jest obsługa klienta.',
  },
  {
    question: 'Co to jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet to uporządkowana baza produktów w formie arkusza, która zawiera setki sprawdzonych produktów z chińskich platform zakupowych. Arkusz jest podzielony na kategorie takie jak buty, odzież, akcesoria i wiele innych, co pozwala na szybkie odnalezienie interesujących przedmiotów bez konieczności ręcznego przeszukiwania chińskich stron.',
  },
  {
    question: 'Jak działa wysyłka Kakobuy do Polski?',
    answer: 'Kakobuy oferuje kilka opcji wysyłki do Polski, w tym standardową wysyłkę lotniczą oraz ekspresową. Czas dostawy wynosi zazwyczaj od 7 do 21 dni, w zależności od wybranej metody. Koszty wysyłki są kalkulowane na podstawie wagi paczki i wybranej metody dostawy. Wszystkie szczegóły są widoczne przed finalizacją zamówienia.',
  },
  {
    question: 'Jak sprawdzić jakość produktu przed wysyłką?',
    answer: 'Kakobuy oferuje usługę zdjęć QC (Quality Control), które są wykonywane po dotarciu produktu do magazynu Kakobuy w Chinach. Zdjęcia QC pokazują rzeczywisty stan produktu, co pozwala na weryfikację jakości przed wysyłką do Polski. W przypadku niezgodności można poprosić o wymianę lub zwrot u sprzedawcy.',
  },
  {
    question: 'Czy Kakobuy Spreadsheet jest darmowy?',
    answer: 'Tak, dostęp do Kakobuy Spreadsheet jest całkowicie darmowy. Arkusz zawiera linki do produktów, które można przeglądać bez żadnych opłat. Koszty dotyczą wyłącznie zakupu produktów oraz wysyłki, które są realizowane bezpośrednio przez platformę Kakobuy.',
  },
  {
    question: 'Jakie platformy zakupowe obsługuje Kakobuy?',
    answer: 'Kakobuy obsługuje trzy główne chińskie platformy zakupowe: Taobao (największy chiński marketplace), Weidian (platforma z niższymi cenami) oraz 1688 (platforma hurtowa). Kakobuy Spreadsheet zawiera produkty ze wszystkich tych platform, co daje dostęp do najszerszego wyboru produktów z Chin.',
  },
  {
    question: 'Jak często aktualizowany jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet jest regularnie aktualizowany - nowe produkty są dodawane, a niedostępne usuwane. Aktualizacje obejmują również zmiany cen i dostępności produktów. Dzięki temu użytkownicy zawsze mają dostęp do najbardziej aktualnych informacji o produktach.',
  },
  {
    question: 'Czy potrzebuję konta Kakobuy aby korzystać ze Spreadsheet?',
    answer: 'Do przeglądania Kakobuy Spreadsheet nie potrzebujesz konta - arkusz jest dostępny publicznie. Jednak do składania zamówień i korzystania z usług agenta zakupowego Kakobuy konieczne jest założenie bezpłatnego konta na platformie Kakobuy.',
  },
  {
    question: 'Jakie są koszty korzystania z Kakobuy?',
    answer: 'Kakobuy pobiera prowizję od każdego zamówienia, która pokrywa koszty obsługi, magazynowania i pakowania. Dokładne stawki prowizji są dostępne na stronie Kakobuy. Dodatkowo płacisz za same produkty oraz za wysyłkę do Polski. Wszystkie koszty są transparentne i widoczne przed złożeniem zamówienia.',
  },
  {
    question: 'Co zrobić jeśli produkt jest uszkodzony lub niezgodny z opisem?',
    answer: 'W przypadku otrzymania uszkodzonego produktu lub produktu niezgodnego z opisem, Kakobuy oferuje wsparcie w procesie reklamacji. Zdjęcia QC wykonane przed wysyłką stanowią dowód stanu produktu. Proces reklamacji różni się w zależności od sprzedawcy i platformy, ale Kakobuy pomaga w kontakcie ze sprzedawcą i negocjacji rozwiązania.',
  },
  {
    question: 'Czy mogę używać Kakobuy Spreadsheet na telefonie?',
    answer: 'Tak, Kakobuy Spreadsheet jest dostępny w formie arkusza Google, który można przeglądać na dowolnym urządzeniu - telefonie, tablecie czy komputerze. Aplikacja Google Sheets jest darmowa i dostępna na iOS oraz Androida, co umożliwia wygodne przeglądanie produktów również na urządzeniach mobilnych.',
  },
];

export const navLinks = [
  { label: 'Strona główna', href: '/' },
  { label: 'Kategorie', href: '#kategorie' },
  { label: 'Poradnik', href: '#poradnik' },
  { label: 'Bezpieczeństwo', href: '#bezpieczenstwo' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Artykuły', href: '/poradnik-kakobuy' },
];